import BaseModelFactory from './base.factory'
import PerformanceRecordService from './../services/PerformanceRecord.service'
import PerformanceRecord from './../models/performance-record.model'

class PerformanceRecordFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: PerformanceRecordService, Model: PerformanceRecord }
    )
  static findById = async id =>
    await this._findBy({ id: id }, { Service: PerformanceRecordService, Model: PerformanceRecord })
  static findAllById = async id =>
    await this._findAllBy({ id: id }, { Service: PerformanceRecordService, Model: PerformanceRecord })
  static create = payload =>
    this._create(payload, {
      Service: PerformanceRecordService,
      Model: PerformanceRecord,
    })
}

export default PerformanceRecordFactory
